export default "/images/602b16331e24e6aebb6ac12b656a78c7.avif";